import { render, staticRenderFns } from "./ModalEventNotification.vue?vue&type=template&id=0acbc50e&scoped=true"
import script from "./ModalEventNotification.vue?vue&type=script&lang=js"
export * from "./ModalEventNotification.vue?vue&type=script&lang=js"
import style0 from "./ModalEventNotification.vue?vue&type=style&index=0&id=0acbc50e&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0acbc50e",
  null
  
)

export default component.exports